<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="w-full mb-4" v-has-permission="'CreateSaleTarget'">
          <vs-button
            @click.prevent="onCreateSaleTargetButton"
            class="bg_l_green"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("CreateSaleTarget") }}
          </vs-button>
        </div>
        <create-sale-target
          :show="showCreateSaleTargetPopup"
          @close="closeCreateSaleTargetPopup"
          @finish="onCreateSaleTargetFinish"
        >
        </create-sale-target>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              v-if="$tabHasPermission('GetAllByPageInfo')"
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name') },
                { title: $t('FromDate') },
                { title: $t('ToDate') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 25%">
                  {{ row.name }}
                </td>
                <td style="width: 25%">
                  {{ row.from }}
                </td>
                <td style="width: 25%">
                  {{ row.to }}
                </td>
                <td style="width: 25%">
                  <div class="flex gap-2 items-center justify-center">
                    <router-link
                      v-has-permission="'GetAllSegmentTarget'"
                      :to="{
                        path: `/SaleTargets/${row.id}/Segments/`,
                        query: { breadcrumbName: row.name },
                      }"
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="flex gap-2 px-2 py-1"
                        >{{ $t("ProductSegments") }}</vs-button
                      >
                    </router-link>
                    <vs-button
                      v-has-permission="'RemoveSaleTarget'"
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="removeSaleTarget(row.id)"
                      class="d-inline"
                    ></vs-button>
                  </div>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import CreateSaleTarget from "./CreateSaleTarget.vue";

export default {
  components: {
    DataGrid,
    CreateSaleTarget,
  },
  data() {
    return {
      currentPlan: {},
      gridDataSource: {
        type: "app",
        service: "/Sales/api/SaleTargetsQuery",
      },
      gridSearchData: {},
      showCreateSaleTargetPopup: false,
      showSalesTargetPopup: false,
      showModifyPlan: false,
    };
  },
  methods: {
    ...mapActions({
      deleteSaleTarget: "saleTarget/deleteSaleTarget",
    }),
    closeCreateSaleTargetPopup() {
      this.showCreateSaleTargetPopup = false;
    },
    onSalesTargetButton(row) {
      this.currentPlan = row;
      this.showSalesTargetPopup = true;
    },
    onCreateSaleTargetButton() {
      this.showCreateSaleTargetPopup = true;
    },
    editPromoterPlanName(model) {
      this.modelModify = {
        id: model.id,
        name: model.name,
      };
      this.showModifyPlan = true;
    },
    closeProductsListPopup() {
      this.showSalesTargetPopup = false;
    },
    closeCreatePlanPopup() {
      this.showNewCreatePlan = false;
    },
    closeModifyPopup() {
      this.showModifyPlan = false;
    },
    onCreateSaleTargetFinish() {
      this.closeCreateSaleTargetPopup();
      this.$refs.grid.renderGrid(1, true);
    },
    removeSaleTarget(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          const payload = { id };
          this.deleteSaleTarget(payload).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            setTimeout(() => {
              this.$refs.grid.renderGrid();
            }, 300);
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.mangement-btn {
  display: inline-block;
  margin: 0 15px;
  padding: 0.25rem 2rem !important;

  & i {
    display: inline-block;
    margin-left: 4px;
  }
}
</style>
